import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/assets/css/scss/main.css";
import "../src/assets/css/responsive.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import Organization from "./DashboardComponent/Outer/Organization.js";
import Login from "./DashboardComponent/Outer/Login.js";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import ForgetEmail from "./DashboardComponent/Outer/ForgetEmail.js";
import UpdatePassword from "./DashboardComponent/Outer/UpdatePassword.js";
import { Unsubscribe } from "./DashboardComponent/Outer/Unsubscribe.jsx";
import { VerifyEmail } from "./DashboardComponent/Outer/VerifyEmail.jsx";
import Dashboard from "./DashboardComponent/Admin-dashboard/Dashboard.js";
import ChangePassword from "./CommonComponent/ChangePassword/ChangePassword.js";
import PrivateRoute from "./privateRoute/PrivateRoute.jsx";
// WA-006: import { OrganizationPayment } from "./DashboardComponent/Outer/OrganizationPayment.js";
import UserRegistration from "./DashboardComponent/Outer/UserRegistration.js";

import ForgotPassword from "./DashboardComponent/Outer/ForgotPassword.js";
import { ViewOrganization } from "./DashboardComponent/Outer/ViewOrganization.js";
import { SuperDashboard } from "./DashboardComponent/Super-admin/SuperDashboard.js";
import { Player_dashboard } from "./DashboardComponent/Player/Player_dashboard.js";
import { Managers } from "./DashboardComponent/Player/Managers.js";
import { Profile } from "./CommonComponent/Profile/Profile.js";
import { PageNotFound } from "./DashboardComponent/Outer/PageNotFound.js";
import { User } from "./DashboardComponent/Admin-dashboard/User.js";
import { Sports } from "./DashboardComponent/Super-admin/Sports.js";
import { Team } from "./DashboardComponent/Super-admin/Team.js";
import { Tournament } from "./DashboardComponent/Super-admin/Tournament.js";
import { CreateTournament } from "./DashboardComponent/Super-admin/CreateTournament.js";
import WizardFormStepper from "./DashboardComponent/Outer/WizardFormStepper.js";
import { UserSuper } from "./DashboardComponent/Super-admin/UserSuper.js";
import { Auction } from "./DashboardComponent/Super-admin/Auction.js";
import { CreateAuction } from "./DashboardComponent/Super-admin/CreateAuction.js";
import { Winners } from "./DashboardComponent/Super-admin/Winners.js";
// FE-17: one results screen per family, mounted from every role's routes below.
import { AuctionResults } from "./CommonComponent/Results/AuctionResults.jsx";
import { SecondaryMarketResults } from "./CommonComponent/Results/SecondaryMarketResults.jsx";
import { AuctionDetails, PlaceBidRedirect } from "./DashboardComponent/Player/AuctionDetails.jsx";
import { SetupBracket } from "./DashboardComponent/Super-admin/SetupBracket.js";
import AuctionPlayer from "./DashboardComponent/Player/AuctionPlayer.js";
import { Bid } from "./DashboardComponent/Player/Bid.js";
import { Home } from "./DashboardComponent/Outer/Home.js";
import { Notification } from "./DashboardComponent/Player/Notification.js";

import { Account_settings } from "./DashboardComponent/Player/Account_settings.js";
import { Secondary_Market } from "./DashboardComponent/Player/Secondary_Market.js";
import { Admin } from "./DashboardComponent/Super-admin/Admin.js";
import { Admin_report } from "./DashboardComponent/Admin-dashboard/Admin_report.js";
import { Admin_notification } from "./DashboardComponent/Admin-dashboard/Admin_notification.js";
import { Admin_auction } from "./DashboardComponent/Admin-dashboard/Admin_auction.js";
import { PaymentCancel } from "./DashboardComponent/Outer/stripe/PaymentCancel.js";
import { PaymentSuccess } from "./DashboardComponent/Outer/stripe/PaymentSuccess.js";
import SuperNotification from "./DashboardComponent/Super-admin/SuperNotification.js";
import RemountOnNavigate from "./CommonComponent/RemountOnNavigate.jsx";
import { BroadcastingCenter } from "./DashboardComponent/Super-admin/BroadcastingCenter.jsx";
import { SendBroadcast } from "./DashboardComponent/Super-admin/SendBroadcast.jsx";
import { BroadcastDetails } from "./DashboardComponent/Super-admin/BroadcastDetails.jsx";
// Disabled with /WebAdmin/AccountHistory (WEB-72).
// import { AccountHistory } from "./DashboardComponent/Admin-dashboard/AccountHistory.js";
import { AboutUs } from "./DashboardComponent/Outer/AboutUs.js";
import { Features } from "./DashboardComponent/Outer/Features.js";
import { Works } from "./DashboardComponent/Outer/Works.js";
import { ContactUs } from "./DashboardComponent/Outer/ContactUs.js";
import { AccounSetting } from "./DashboardComponent/Super-admin/AccounSetting.js";
import { Query } from "./DashboardComponent/Admin-dashboard/Query.js";
import { SecodaryPlaceBid } from "./DashboardComponent/Player/SecodaryPlaceBid.js";
import { SecodaryBid } from "./DashboardComponent/Player/SecodaryBid.js";

import { Faq } from "./DashboardComponent/Outer/Faq.js";
import { ManagerTips } from "./DashboardComponent/Outer/ManagerTips.js";
import { Generate_PromoCode } from "./DashboardComponent/Admin-dashboard/Generate_PromoCode.js";
import { ToastContainer } from "react-toastify";
import { SignalRUrl } from "./utils/config/config.js";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSignalRConnection } from "./redux/auth-reducer/auth-reducer.js";
// Batch 4.1 (#82 MG-008, #83 MG-009, #84 AD-008, #85 AD-009): bracket system disabled. These
// three screens are bracket-only and are unrouted below. The files are left on disk untouched -
// with no import reaching them webpack never bundles them, so restoring is uncommenting here.
//   Bracket           - public hard-coded demo bracket at /bracket
//   TournamentBracket - static demo page at /SuperAdmin/TouramentBrackat, no API calls
//   TestBracket       - near-copy of SetupBracket at /SuperAdmin/test/:id
// import {Bracket} from "./DashboardComponent/Outer/Bracket.js";
// import TournamentBracket from "./DashboardComponent/Super-admin/TournamentBracket.js";
// import { TestBracket } from "./DashboardComponent/Super-admin/TestBracket.js";
import { UserInactive } from "./DashboardComponent/Admin-dashboard/UserInactive.js";
import PrivacyPolicy from "./DashboardComponent/Outer/PrivacyPolicy.js";



// MG-003.1 (#125): a data router rather than a <BrowserRouter>, because only a data router supports
// useBlocker - which Auction Results uses to hold a navigation while it has unsaved Team Buyback
// changes. The route tree itself is unchanged.
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Home />} />
      <Route path="/Organization" element={<Organization />} />
      {/* Batch 4.1: bracket system disabled.
      <Route path="/bracket" element={<Bracket />} /> */}
      <Route path="/Login" element={<Login />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/AboutUs" element={<AboutUs />} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/Features" element={<Features />} />
      <Route path="/Works" element={<Works />} />
      <Route path="/ContactUs" element={<ContactUs />} />
      <Route path="/UserRegistration" element={<UserRegistration />} />
      <Route path="/ForgotPassword" element={<ForgotPassword />} />
      <Route path="/ForgetEmail" element={<ForgetEmail />} />
      <Route path="/UpdatePassword/:id" element={<UpdatePassword />} />
      {/* The link in every Broadcasting Center email; public, the link's token names the player. */}
      <Route path="/Unsubscribe" element={<Unsubscribe />} />
      <Route path="/VerifyEmail" element={<VerifyEmail />} />
      <Route path="*" element={<PageNotFound />} />
      <Route path="WizardFormStepper" element={<WizardFormStepper />} />
      <Route path="PaymentCancel" element={<PaymentCancel />} />
      <Route path="PaymentSuccess" element={<PaymentSuccess />} />
      <Route path="Faq" element={<Faq />} />
      <Route path="ManagerTips" element={<ManagerTips />} />

      <Route path="WebAdmin">
        <Route element={<PrivateRoute allowedRoles={["Web Admin"]} />}>
          <Route path="" element={<Dashboard />} />
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="ChangePassword" element={<ChangePassword />} />
          <Route path="ViewOrganization" element={<ViewOrganization />} />
          <Route path="Profile" element={<Profile />} />
          <Route path="User" element={<User />} />
          <Route path="UserInactive" element={<UserInactive />} />
          <Route path="Admin_report" element={<Admin_report />} />
          <Route path="Generate_PromoCode" element={<Generate_PromoCode />} />
          <Route path="AuctionResult" element={<AuctionResults />} />
          <Route
            path="Admin_notification"
            element={<Admin_notification />}
          />
          <Route
            path="Query"
            element={<Query />}
          />
          <Route path="Admin_auction" element={<Admin_auction />} />
          {/* Disabled (WEB-72): the page called Stripe/GetAllPaymentHistory, which
              serves every user's payment rows unfiltered. It had no sidebar entry and
              was reachable only by typing the URL, which PrivateRoute let any signed-in
              role do. Now falls through to the "*" PageNotFound route. */}
          {/* <Route path="AccountHistory" element={<AccountHistory />} /> */}
          <Route path="SecondaryMarketResults" element={<SecondaryMarketResults showLevel />} />
        </Route>
      </Route>

      <Route path="SuperAdmin">
        {/* FE-01: Admin accounts work these screens too - Login.js sends them here. */}
        <Route element={<PrivateRoute allowedRoles={["Manager", "Admin"]} />}>
          <Route path="" element={<SuperDashboard />} />
          <Route path="SuperDashboard" element={<SuperDashboard />} />
          {/* WA-006: a static pricing page with no API calls, reachable only by typing the
              URL - nothing in src/ links to it.
          <Route path="OrganizationPayment" element={<OrganizationPayment />} />
          */}
          <Route path="UserSuper" element={<UserSuper />} />
          <Route path="Profile" element={<Profile />} />
          <Route path="ChangePassword" element={<ChangePassword />} />
          <Route path="Sports" element={<Sports />} />
          <Route path="Team" element={<Team />} />
          <Route path="Auction" element={<Auction />} />
          <Route path="Contest" element={<Tournament />} />
          <Route path="CreateContest" element={<CreateTournament />} />
          <Route path="CreateAuction" element={<CreateAuction />} />
          <Route path="AuctionResults" element={<AuctionResults />} />
          {/* MG-012 / AD-012: Manager and Admin see the same winners list. */}
          <Route path="Winners" element={<Winners />} />
          {/* #158: a contest's Results - its match date and player scores. The component keeps
              its pre-#82 name; the old SetupBracket/:id path is gone and 404s. */}
          <Route path="ContestResults/:id" element={<SetupBracket />} />
          <Route path="Admin" element={<Admin />} />
          {/* #218 review: re-created on every arrival, so a bell link clicked on this page reloads
              it and marks it read again (RemountOnNavigate). */}
          <Route
            path="SuperNotification"
            element={
              <RemountOnNavigate>
                <SuperNotification />
              </RemountOnNavigate>
            }
          />
          {/* MG-014 / AD-013 (#167, #168): the Broadcasting Center - the history, Send Broadcast and
              Broadcast Details. Manager and Admin share it; the server scopes it to their team. */}
          <Route path="BroadcastingCenter" element={<BroadcastingCenter />} />
          <Route path="BroadcastingCenter/Send" element={<SendBroadcast />} />
          <Route path="BroadcastingCenter/:id" element={<BroadcastDetails />} />
          <Route path="AccounSetting" element={<AccounSetting />} />
          <Route path="Secondary_Market_Results" element={<SecondaryMarketResults showLevel />} />
          {/* Batch 4.1: bracket system disabled. Both were orphaned - nothing linked to
              them - but they were reachable by URL under the same Manager/Admin guard.
          <Route path="TouramentBrackat" element={<TournamentBracket />} />
          <Route path="test/:id" element={<TestBracket />} /> */}
        </Route>
      </Route>

      <Route path="Player">
        <Route element={<PrivateRoute allowedRoles={["Player"]} />}>
          <Route path="" element={<Player_dashboard />} />
          <Route path="ChangePassword" element={<ChangePassword />} />
          <Route path="Player_dashboard" element={<Player_dashboard />} />
          <Route path="Managers" element={<Managers />} />
          <Route path="Profile" element={<Profile />} />
          {/* #237: the old lot page; Place Bid opens Auction Details now. */}
          <Route path="PlaceBid" element={<PlaceBidRedirect />} />
          <Route path="AuctionDetails/:auctionId" element={<AuctionDetails />} />
          <Route path="SecodaryPlaceBid" element={<SecodaryPlaceBid />} />
          <Route path="SecondaryBid" element={<SecodaryBid />} />
          {/* #295: the page's old, misspelled address. */}
          <Route path="SecodaryBid" element={<Navigate to="/Player/SecondaryBid" replace />} />
          <Route path="Bid" element={<Bid />} />
          <Route path="AuctionPlayer" element={<AuctionPlayer />} />
          <Route
            path="Notification"
            element={
              <RemountOnNavigate>
                <Notification />
              </RemountOnNavigate>
            }
          />
          <Route path="Account_settings" element={<Account_settings />} />
          <Route path="Secondary_Market" element={<Secondary_Market />} />
          <Route path="AuctionResults" element={<AuctionResults />} />
          <Route path="SecondaryMarketResults" element={<SecondaryMarketResults />} />
        </Route>
      </Route>
    </>
  )
);

// #270: a page opened from the header, the burger menu, the footer or any navigate() starts at the
// top - the window kept the previous page's scroll. Back/Forward (POP) keep the browser's position,
// and a same-page navigate (clearing its state, e.g. Auction Details dropping its bid prefill) does
// not scroll.
let lastPathname = router.state.location.pathname;
router.subscribe(({ location, historyAction }) => {
  if (location.pathname === lastPathname) return;
  lastPathname = location.pathname;
  if (historyAction !== "POP") window.scrollTo({ top: 0, left: 0, behavior: "instant" });
});

function App() {

  return (
    <div className="App">
      <ToastContainer />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
